/* Catalogue rules shared by the storefront and the QA suite. No price or stock constants. */
(function (root) {
  'use strict';
  const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const tags = p => Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(s => s.trim());
  const optionNames = p => (p.options || []).map(o => typeof o === 'string' ? o : o.name);
  const optionValues = (p, index) => [...new Set((p.variants || []).map(v => (v.options || [v.option1, v.option2, v.option3])[index]).filter(Boolean))];
  const tagValue = (p, prefix) => (tags(p).find(t => t.startsWith(prefix)) || '').slice(prefix.length);
  const internal = p => ['Internal', 'DNU'].includes(p.type);
  function gender(p) { return p.type?.startsWith('Women:') ? 'femme' : p.type?.startsWith('Men:') ? 'homme' : 'neutre'; }
  function kind(p) {
    const t = p.type || '';
    if (t.includes(':Shoes:')) return 'chaussures';
    if (t.includes(':Bag:')) return 'sacs';
    if (t.includes(':Accessories:') || t.startsWith('Accessories:')) return 'accessoires';
    if (t.endsWith(':Leggings')) return 'leggings';
    if (t.endsWith(':Bras')) return 'brassieres';
    if (t.includes(':Coverups:')) return 'sweats';
    if (t.endsWith(':Jackets') || t.endsWith(':Vests')) return 'vestes';
    if (t.endsWith(':Pants') || t.endsWith(':Sweatpants')) return 'pantalons';
    if (t.endsWith(':Shorts')) return 'shorts';
    if (t.endsWith(':Dresses') || t.endsWith(':Skirts')) return 'robes-jupes';
    if (t.includes(':Tops:')) return 'hauts';
    if (t.includes(':One Piece:')) return 'combinaisons';
    if (t.startsWith('Beauty:') || t.startsWith('Wellness:')) return 'beaute-bien-etre';
    if (t.includes('Gift Card')) return 'cartes-cadeaux';
    if (t === 'Books') return 'livres';
    return 'autres';
  }
  function color(p) {
    const i = optionNames(p).findIndex(o => /^(color|colour|coloris|couleur)$/i.test(o));
    return (i >= 0 ? optionValues(p, i)[0] : '') || tagValue(p, 'Color:').replace(/:Color$/, '');
  }
  function colorLabel(p) { const c = color(p); return /^(no color|default title)$/i.test(c) ? '' : (p.title?.includes(' - ') ? p.title.split(' - ').pop() : c); }
  let merchandising = new Map();
  function configureMerchandising(data) {
    merchandising = new Map(Object.entries(data || {}).filter(([,v]) => v && typeof v.new === 'boolean' && typeof v.best === 'boolean'));
  }
  const best = p => merchandising.get(p.handle)?.best ?? tags(p).some(t => t === 'b:1:Best Seller' || /^(Status:)?[WAMB]*BestSeller$/.test(t));
  const isNew = p => merchandising.get(p.handle)?.new ?? tags(p).includes('b:3:New');
  const limited = p => tags(p).includes('ColorwayType:Limited');
  const style = p => tagValue(p, 'StyleId:');
  const familyKey = p => style(p) ? gender(p) + '|' + style(p) : 'handle|' + p.handle;
  const activities = p => tags(p).filter(t => /^(Women:|Men:)?Activity:/.test(t)).map(t => t.split(':').pop());
  function capsule(p) {
    const h = p.handle || '';
    // Suit Up trousers and Airlift Suit Up activewear are separate families.
    if (h.includes('airlift') && /(?:^|-)suit-up(?:-|$)/.test(h)) return 'airlift-suit-up';
    const name = (h.match(/(?:^|-)(heart-throb|muse|accolade|sway|momentum|serenity|chill|double-take|socialite|reset|mini-cable|alpine-meadow|eternity|trifecta|polka-dot|precision|finesse|daylight|double-up|best-bet|superstar|line-up|sincere|favorite|weekend-escape|better-together|micro-chenille|relay|golden-hour|my-serve|two-tone-rib|alignment|charger|winter-bliss|rebel|evolve|love-language|retreat|be-mine|waffle-chenille-edition|waffle-lounge|alpha-shell|takeaway-track|shift-knit|conquer-max|axis|new-class)(?:-|$)/) || [])[1] || '';
    if (!name) return '';
    const fabric = (h.match(/(?:^|-)(airlift|airbrush|alosoft|alo-softsculpt)(?:-|$)/) || [])[1] || '';
    return (fabric ? fabric + '|' : '') + name;
  }
  const isTop = p => ['hauts','sweats','brassieres','vestes'].includes(kind(p));
  const isBottom = p => ['leggings','pantalons','shorts','robes-jupes'].includes(kind(p));
  function prepare(products) {
    const list = products.filter(p => p && p.handle && !internal(p));
    const families = new Map(), sets = new Map();
    for (const p of list) {
      const key = familyKey(p); if (!families.has(key)) families.set(key, []); families.get(key).push(p);
      const cap = capsule(p); if (cap) {const key2 = gender(p)+'|'+cap+'|'+color(p); if(!sets.has(key2)) sets.set(key2,[]); sets.get(key2).push(p);}
    }
    const colorOrder=['Black','White','Athletic Heather Grey','Espresso','Navy','White Heather','California Blue','Oatmeal Heather'];
    for (const family of families.values()) family.sort((a,b)=>Number(limited(a))-Number(limited(b)) || (colorOrder.indexOf(color(a))<0?99:colorOrder.indexOf(color(a)))-(colorOrder.indexOf(color(b))<0?99:colorOrder.indexOf(color(b))) || color(a).localeCompare(color(b),'fr'));
    for (const p of list) {
      p._family = families.get(familyKey(p));
      const set = sets.get(gender(p)+'|'+capsule(p)+'|'+color(p)) || [];
      p._set = !!capsule(p) && ((isTop(p) && set.some(isBottom)) || (isBottom(p) && set.some(isTop)));
    }
    return list;
  }
  const categoryDefs = {
    tout: ['Tout le catalogue', () => true],
    femme: ['Femme', p => gender(p) === 'femme'],
    homme: ['Homme', p => gender(p) === 'homme'],
    accessoires: ['Accessoires', p => ['accessoires','sacs','chaussures'].includes(kind(p))],
    chaussures: ['Chaussures', p => kind(p) === 'chaussures'],
    sacs: ['Sacs', p => kind(p) === 'sacs'],
    leggings: ['Leggings', p => kind(p) === 'leggings'],
    brassieres: ['Brassières', p => kind(p) === 'brassieres'],
    'robes-jupes': ['Robes et jupes', p => kind(p) === 'robes-jupes'],
    ensembles: ['Ensembles assortis', p => !!p._set],
    bamboo: ['Vert bambou', p => color(p).split('/').includes('Bamboo Green')],
    california: ['Bleu Californie', p => color(p).split('/').includes('California Blue')],
    navy: ['Bleu marine', p => color(p).split('/').includes('Navy')],
    espresso: ['Espresso', p => color(p).split('/').includes('Espresso')],
    softsculpt: ['ALO Softsculpt', p => p.handle.includes('softsculpt')],
    detente: ['Détente', p => activities(p).some(a => ['Lounge','Loungewear'].includes(a))],
    pilates: ['Pilates', p => activities(p).includes('Pilates')],
    yoga: ['Yoga', p => activities(p).includes('Yoga')],
    running: ['Running', p => activities(p).includes('Run')],
    entrainement: ['Entraînement', p => activities(p).includes('Train')],
    tennis: ['Tennis', p => activities(p).some(a => ['Court','CourtSports'].includes(a))],
    'beaute-bien-etre': ['Beauté et bien-être', p => kind(p) === 'beaute-bien-etre'],
    'cartes-cadeaux': ['Cartes cadeaux', p => kind(p) === 'cartes-cadeaux'],
    livres: ['Livres', p => kind(p) === 'livres']
  };
  const kindLabels = {hauts:'Hauts',sweats:'Sweatshirts et pulls',pantalons:'Pantalons',shorts:'Shorts',vestes:'Vestes',combinaisons:'Combinaisons',leggings:'Leggings',brassieres:'Brassières','robes-jupes':'Robes et jupes',accessoires:'Accessoires',chaussures:'Chaussures',sacs:'Sacs','beaute-bien-etre':'Beauté et bien-être','cartes-cadeaux':'Cartes cadeaux',livres:'Livres',autres:'Autres'};
  for (const g of ['femme','homme']) {
    for (const k of ['hauts','sweats','pantalons','shorts','vestes','combinaisons']) categoryDefs[g+'-'+k] = [kindLabels[k]+' '+g,p=>gender(p)===g && kind(p)===k];
    categoryDefs[g+'-nouveautes'] = ['Nouveautés '+g,p=>gender(p)===g && isNew(p)];
    categoryDefs[g+'-meilleures-ventes'] = ['Meilleures ventes '+g,p=>gender(p)===g && best(p)];
    categoryDefs[g+'-ensembles'] = ['Ensembles assortis '+g,p=>gender(p)===g && !!p._set];
  }
  const category = (products, key) => categoryDefs[key] ? products.filter(p => !internal(p) && categoryDefs[key][1](p)) : [];
  function query(products, state) {
    let list = category(products, state.category || 'tout');
    if (state.q) {const terms = norm(state.q).split(/\s+/).filter(Boolean); list = list.filter(p => terms.every(t => norm(p.title+' '+colorLabel(p)+' '+kindLabels[kind(p)]).includes(t)));}
    list = list.filter(p => {
      if (state.type && kind(p) !== state.type) return false;
      if (state.color && color(p) !== state.color) return false;
      const si = optionNames(p).findIndex(o => /^(size|taille)$/i.test(o));
      if (state.size && (si < 0 || !(p.variants || []).some(v => v.available && (v.options || [v.option1,v.option2,v.option3])[si] === state.size))) return false;
      if (state.min !== '' && state.min != null && p.price < Number(state.min)*100) return false;
      if (state.max !== '' && state.max != null && p.price > Number(state.max)*100) return false;
      return true;
    });
    list = list.slice();
    const tie = (a,b) => a.handle.localeCompare(b.handle);
    if(state.sort==='price-asc') list.sort((a,b)=>a.price-b.price || tie(a,b));
    else if(state.sort==='price-desc') list.sort((a,b)=>b.price-a.price || tie(a,b));
    else if(state.sort==='title') list.sort((a,b)=>a.title.localeCompare(b.title,'fr') || tie(a,b));
    const total = list.length, pages = Math.max(1,Math.ceil(total/24));
    const page = Math.min(pages,Math.max(1,Math.floor(Number(state.page)||1)));
    return {items:list.slice((page-1)*24,page*24),total,pages,page,all:list};
  }
  function variant(p, values) {
    if(optionNames(p).some((_,i) => !values[i])) return null;
    return (p.variants || []).find(v => (v.options || [v.option1,v.option2,v.option3]).every((x,i)=>x===values[i])) || null;
  }
  function availableValue(p,values,index,value) {return (p.variants || []).some(v => v.available && (v.options || [v.option1,v.option2,v.option3]).every((x,i)=>i===index ? x===value : !values[i] || x===values[i]));}
  function recommendations(p, list, curated=[]) {
    const used=new Set([p.handle]);
    const take=(items,n)=>items.filter(x=>x.handle!==p.handle && !used.has(x.handle)).slice(0,n).map(x=>(used.add(x.handle),x));
    const sameGender = list.filter(x=>gender(x)===gender(p));
    const reference = p.handle==='u3040rg-accolade-1-4-zip-pullover-navy';
    const picks=Array.isArray(curated)?{look:curated}:curated;
    const resolve=key=>(picks[key]||[]).map(h=>sameGender.find(x=>x.handle===h)).filter(Boolean);
    const matches = sameGender.filter(x=>capsule(p) && capsule(x)===capsule(p) && color(x)===color(p) && ((isTop(p)&&isBottom(x)) || (isBottom(p)&&isTop(x))));
    const preferred = reference ? resolve('look').filter(x=>matches.includes(x)) : [];
    const look = take([...preferred,...matches.filter(x=>!preferred.includes(x))],6);
    const similar = take(reference && picks.similar ? resolve('similar') : sameGender.filter(x=>x.type===p.type && style(x)!==style(p)).sort((a,b)=>(color(b)===color(p))-(color(a)===color(p))),8);
    const more = take(reference && picks.more ? resolve('more') : sameGender.filter(x=>kind(x)!==kind(p) && color(x)===color(p) && activities(x).some(a=>activities(p).includes(a))),8);
    return {look,similar,more};
  }
  const api={norm,tags,optionNames,optionValues,internal,gender,kind,color,colorLabel,configureMerchandising,best,isNew,limited,style,familyKey,activities,capsule,prepare,categoryDefs,kindLabels,category,query,variant,availableValue,recommendations};
  if(typeof module==='object' && module.exports) module.exports=api; else root.AloCatalog=api;
})(typeof globalThis!=='undefined'?globalThis:this);
